import {LotoCardboardRepository} from "../ports/LotoCardboardRepository";

export class DeleteAllLotoCardboards {
    constructor(private readonly repo: LotoCardboardRepository) {}

    async execute(): Promise<void> {
        await this.repo.deleteAll();
    }
}
